import { Lang } from '@models/lang';
import { CodeBracketIcon, CubeIcon } from '@heroicons/react/24/solid';
import { FunctionComponent } from 'react';

interface Props {
  lang: Lang;
}

const CardContent: FunctionComponent<Props> = ({ lang }) => {
  return (
    <div className="group rounded-lg relative shadow overflow-hidden border-4 bg-gray-100 hover:bg-gray-300">
      <div className="px-6 py-6 relative flex space-x-2">
        <div>
          <i className={`${lang.icon} text-gray-900 text-6xl`}></i>
        </div>
        <div className="w-full">
          <h3 className="text-xl m-0 font-medium text-gray-900 mb-2">{lang?.title}</h3>
          <div className="flex justify-between w-full">
            <div className="flex space-x-2 items-center">
              <span className="h-4 w-4 text-gray-900">
                <CodeBracketIcon />
              </span>
              <p className="m-0 text-xs text-gray-900">
                {lang?.countExercises === 0 ? '--' : lang?.countExercises} Ejercicios
              </p>
            </div>
            <div className="flex space-x-2 items-center">
              <span className="h-4 w-4 text-gray-900">
                <CubeIcon />
              </span>
              <p className="m-0 text-xs text-gray-900">
                {lang?.countConcepts === 0 ? '--' : lang?.countConcepts} Conceptos
              </p>
            </div>
          </div>
        </div>
        {lang.label && (
          <div className="absolute top-2 right-2">
            <div className="bg-yellow-100 text-yellow-800 text-xs font-semibold mr-2 px-2.5 py-0.5 rounded">
              {lang.label}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CardContent;
